import {
  ClusterIcon,
  InstancesIcon,
  NetworkIcon,
  RegionIcon,
} from '@/assets/icons'
import { ROUTES, ROUTES_TITLES, type ItemConfig } from './navigation'

export const SIDEBAR_CONFIG: ItemConfig[] = [
  {
    path: ROUTES.INFRA_DATACENTERS,
    label: 'Datacenters',
    title: ROUTES_TITLES[ROUTES.INFRA_DATACENTERS],
    icon: <RegionIcon />,
  },
  {
    path: ROUTES.INFRA_CLUSTERS,
    label: 'Clusters',
    title: ROUTES_TITLES[ROUTES.INFRA_CLUSTERS],
    icon: <ClusterIcon />,
  },
  {
    path: ROUTES.INFRA_SERVERS,
    label: 'Servers',
    title: ROUTES_TITLES[ROUTES.INFRA_SERVERS],
    icon: <InstancesIcon />,
  },
  {
    path: ROUTES.INFRA_NETWORK,
    label: 'Network',
    title: ROUTES_TITLES[ROUTES.INFRA_NETWORK],
    icon: <NetworkIcon />,
  },
]
